import { Component } from "react"
import {
    Col,
    Container,
    Row,
} from "reactstrap"
import { NavLink, Link } from "react-router-dom";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { withRouter } from "react-router-dom"

import HomeSvg from "../../components/CustomSvg/HomeSvg"
import FolderSvg from "../../components/CustomSvg/FolderSvg"
import CubeSvg from "../../components/CustomSvg/CubeSvg"
import DistributionSpaceSvg from "../../components/CustomSvg/DistributionSpaceSvg"
import FileSvg from "../../components/CustomSvg/FileSvg"
import SettingSvg from "../../components/CustomSvg/SettingSvg"
import CurrencyDollarSvg from "../../components/CustomSvg/CurrencyDollarSvg"
import EvoShieldLoginLogo from "../../assets/image/evoshield-high-res-logo.png"
import './ContentManagement.scss'

class ContentManagement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            user: localStorage.getItem("authUser") ? JSON.parse(localStorage.getItem("authUser")) : null,
            productMenuOpen: false
        }
    }

    toggleProductMenu = () => {
        this.setState((prevState) => ({
            productMenuOpen: !prevState.productMenuOpen,
        }));
    };

    render() {
        const { path } = this.props.match
        console.log("Current Path:", this.props)
        const { user, productMenuOpen } = this.state
        let fullName = 'Unknow Unkown'
        let userName = 'UU'
        if (user) {
            userName = user.first_name.substring(0, 1) + ' ' + user.last_name.substring(0, 1);
            fullName = user.first_name + ' ' + user.last_name;
        }
        const productPaths = ['/cms/products', '/cms/add-product', '/cms/edit-product/:id']
        const productCategoryPaths = ['/cms/product-category', '/cms/add-product-category', '/cms/edit-product-category/:id']
        return (
            <Container fluid className="cms__main">
                <Row>
                    <Col xs={12} sm={12} md={4} lg={4} xl={3} xxl={3} className="cms__sidebar">
                        <div className="cms__logo">
                            <Link to="/home">
                                <LazyLoadImage
                                    alt={"logo"}
                                    className="logo-image"
                                    src={EvoShieldLoginLogo} // use normal <img> attributes as props
                                />
                            </Link>
                        </div>
                        <ul className="cms__sidebar__menu">
                            <li>
                                <NavLink to="/cms/dashboard">
                                    <HomeSvg />
                                    <span>Dashboard</span>
                                </NavLink>
                            </li>
                            <li className="cms__has_sub_menu">
                                {(() => {
                                    const isProductRoute =
                                        productPaths.includes(path) || productCategoryPaths.includes(path);

                                    const isOpen = productMenuOpen || isProductRoute;

                                    return (
                                        <>
                                            <div
                                                className={`cms__sidebar_sub_head ${isOpen ? "active" : ""}`}
                                                onClick={this.toggleProductMenu}
                                            >
                                                <FolderSvg />
                                                <span>Product Management</span>
                                            </div>

                                            <ul className={`cms__sidebar_sub ${isOpen ? "show" : ""}`}>
                                                <li>
                                                    <NavLink
                                                        to="/cms/products"
                                                        className={productPaths.includes(path) ? "active" : ""}
                                                    >
                                                        <CubeSvg />
                                                        <span>Products</span>
                                                    </NavLink>
                                                </li>

                                                <li>
                                                    <NavLink
                                                        to="/cms/product-category"
                                                        className={productCategoryPaths.includes(path) ? "active" : ""}
                                                    >
                                                        <DistributionSpaceSvg />
                                                        <span>Categories</span>
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </>
                                    );
                                })()}
                            </li>
                            <li>
                                <NavLink to="/cms/orders">
                                    <FileSvg />
                                    <span>Order Management</span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/cms/payment">
                                    <CurrencyDollarSvg />
                                    <span>Payment</span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/cms/settings">
                                    <SettingSvg />
                                    <span>Settings</span>
                                </NavLink>
                            </li>
                        </ul>
                    </Col>
                    <Col className="cms__content px-0">
                        <div className="cms__header">
                            <div className="cms__info_user">
                                <div className="profile__img">{userName}</div>
                                <div className="profile__details">
                                    <div className="profile__name">
                                        <span>{fullName}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="cms__main_content">
                            {this.props.children}
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default (withRouter(ContentManagement))